var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 33,
    height: 33,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_151_37356",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_151_37356",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAADQklEQVR4nO3cz07UQAAG8G+2u6cyXTceMNE3APUdPPHHg4p6kAM3FUx8DvXoES5c8EIUL4gnH8KAb6ARI7C0O6ddOh7sJhMj9O/stOT7XUjY0g7zzdd2uwSAiIiIiIiIiIiIiIiIiIiIiIguG5FloyiKtO2BXEZSytT5bU1iIHQ+BuAYA3CMATjGABxrW9z3ttZ6NQiCI4vHsO74+Ljb6XTeAHhqY/82G/BICLEfhuE9i8ewajAYzHU6nX1YmnygfADfU16/JoTYCcNws9/v90oea2L6/X4vDMNNrfUegBspm6fNwYVKBTAcDmcArKdtJ4RY8TzvWxiG98scbxKUUvOe530VQqxk2Hw7juNbZY5X6p3w+J3eYDCY01pvIH21ADW9NuQ81/9MfoePQPr8XKSSa8DU1NTn4XA4iwxtwN9rw0Gd2qCUms9xrt/WWs+OJ7+sShpgalIbTk5OrrTb7dcosOpNzhtgKtKGKIoeVD2ONEqphXa77WTVmypvgEkpNR/H8Tqyt2EtCILfWcZUVM5Vf6i1fp428bVqgMn3/b2cbdi32YYCq37Gxqo3WW2AyWUbCqz61SAIdrLuv7YNMPm+vzcajW5iwm0ouOozT35ZE2uAKWnDBoDrGTYv1Abbq97UiAaYkjbkvVNayrr/09PTxTqvepOTBpiUUgvJtaF0G/KuegBrUsoPOYb7X41rgMn3/U9VtCFZ9QfIcV9fxeSX5bwBprxtAPDi7Oxs5HneK0x41ZvKzE+tAgCAMAyvCiHeAniSYfPD5Ot0hm3faa1f2njs0ehT0L+CIDiSUi63Wq1FpD9rn0b65B8CWJJSLtftCSxQwwDGcl4bzlObc/15ahsAAPR6vb6U8lkcx3cB/Mjxo78APJRSPrb9bKmsWgcw1u12d0ejUaZP35Dc10sp39seVxUaEQCQqQ2NWfWmxgQw1u12d7XWtwFsGd/eatKqN9XuNjSPKIruJOP44ngchefH5h9mWed64qvQuFPQZcMAHGMAjjEAxxiAYwzAMQbgGANwjAE4xgAcYwCOMQDHGIBjDMAxBuAYA3Cs1Acy/D9C5bEBjjEAxxiAYwzAMQZARERERERERERERERERBb9AZNvvWIrbK5PAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.ee72d4b28627480efe36bbd09750ea57.svg";
export { ForwardRef as ReactComponent };